import data from "../../../../../src/src_config.json";
import axios from "axios";
import {
    SET_LANE_MANAGEMENT_KPI_REQUEST,
    SET_LANE_MANAGEMENT_KPI_SUCCESS,
    SET_LANE_MANAGEMENT_KPI_ERROR,
    SET_LANE_MANAGEMENT_KPI_RESET,
    SET_LONGITUDINAL_MOTION_KPI_REQUEST,
    SET_LONGITUDINAL_MOTION_KPI_SUCCESS,
    SET_LONGITUDINAL_MOTION_KPI_ERROR,
    SET_LONGITUDINAL_MOTION_KPI_RESET,
    SET_SAFE_DRIVING_KPI_REQUEST,
    SET_SAFE_DRIVING_KPI_SUCCESS,
    SET_SAFE_DRIVING_KPI_ERROR,
    SET_SAFE_DRIVING_KPI_RESET,
    SET_EGO_VELOCITY_KPI_REQUEST,
    SET_EGO_VELOCITY_KPI_SUCCESS,
    SET_EGO_VELOCITY_KPI_ERROR,
    SET_EGO_VELOCITY_KPI_RESET,
    SET_L1_LATERAL_ACCELERATION_KPI_REQUEST,
    SET_L1_LATERAL_ACCELERATION_KPI_SUCCESS,
    SET_L1_LATERAL_ACCELERATION_KPI_ERROR,
    SET_L1_LATERAL_ACCELERATION_KPI_RESET,
    SET_L1_LATERAL_JERK_KPI_REQUEST,
    SET_L1_LATERAL_JERK_KPI_SUCCESS,
    SET_L1_LATERAL_JERK_KPI_ERROR,
    SET_L1_LATERAL_JERK_KPI_RESET,
    SET_L1_LONGITUDINAL_DECELERATION_KPI_REQUEST,
    SET_L1_LONGITUDINAL_DECELERATION_KPI_SUCCESS,
    SET_L1_LONGITUDINAL_DECELERATION_KPI_ERROR,
    SET_L1_LONGITUDINAL_DECELERATION_KPI_RESET,
    SET_L1_LONGITUDINAL_ACCELERATION_KPI_REQUEST,
    SET_L1_LONGITUDINAL_ACCELERATION_KPI_SUCCESS,
    SET_L1_LONGITUDINAL_ACCELERATION_KPI_ERROR,
    SET_L1_LONGITUDINAL_ACCELERATION_KPI_RESET,
    SET_L1_LONGITUDINAL_JERK_KPI_REQUEST,
    SET_L1_LONGITUDINAL_JERK_KPI_SUCCESS,
    SET_L1_LONGITUDINAL_JERK_KPI_ERROR,
    SET_L1_LONGITUDINAL_JERK_KPI_RESET,
    SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_REQUEST,
    SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_SUCCESS,
    SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_ERROR,
    SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_RESET,
    SET_L0_COLLISION_CHECK_KPI_REQUEST,
    SET_L0_COLLISION_CHECK_KPI_SUCCESS,
    SET_L0_COLLISION_CHECK_KPI_ERROR,
    SET_L0_COLLISION_CHECK_KPI_RESET,
    SET_L0_LATERAL_SAFE_DISTANCE_KPI_REQUEST,
    SET_L0_LATERAL_SAFE_DISTANCE_KPI_SUCCESS,
    SET_L0_LATERAL_SAFE_DISTANCE_KPI_ERROR,
    SET_L0_LATERAL_SAFE_DISTANCE_KPI_RESET,
    SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_REQUEST,
    SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_SUCCESS,
    SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_ERROR,
    SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_RESET,
    SET_L0_OFF_ROAD_CHECK_KPI_REQUEST,
    SET_L0_OFF_ROAD_CHECK_KPI_SUCCESS,
    SET_L0_OFF_ROAD_CHECK_KPI_ERROR,
    SET_L0_OFF_ROAD_CHECK_KPI_RESET,
    SET_L0_LANE_MARKING_CHECK_KPI_REQUEST,
    SET_L0_LANE_MARKING_CHECK_KPI_SUCCESS,
    SET_L0_LANE_MARKING_CHECK_KPI_ERROR,
    SET_L0_LANE_MARKING_CHECK_KPI_RESET,
    SET_L0_INDICATOR_CHECKING_KPI_SUCCESS,
    SET_L0_INDICATOR_CHECKING_KPI_ERROR,
    SET_L0_INDICATOR_CHECKING_KPI_REQUEST,
    SET_L0_INDICATOR_CHECKING_KPI_RESET,
    SET_L0_SPEED_LIMIT_CHECK_KPI_REQUEST,
    SET_L0_SPEED_LIMIT_CHECK_KPI_SUCCESS,
    SET_L0_SPEED_LIMIT_CHECK_KPI_ERROR,
    SET_L0_SPEED_LIMIT_CHECK_KPI_RESET,
    SET_L0_FALSE_INDICATOR_CHECK_KPI_REQUEST,
    SET_L0_FALSE_INDICATOR_CHECK_KPI_SUCCESS,
    SET_L0_FALSE_INDICATOR_CHECK_KPI_ERROR,
    SET_L0_FALSE_INDICATOR_CHECK_KPI_RESET,
    SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_REQUEST,
    SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_SUCCESS,
    SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_ERROR,
    SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_RESET,
    SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_REQUEST,
    SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_SUCCESS,
    SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_ERROR,
    SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_RESET,
    SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_REQUEST,
    SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_SUCCESS,
    SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_ERROR,
    SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_RESET,
} from "./../../../../constants/closeLoop/kpiDashboard/dashboardGraphs/dashboardGraphConstants";

var URL = "";
if (data["KPI_AWS_LAMBDA_ENABLED"] == true) {
    console.log("lambda enabled for kpi **********************************");
    URL = data["API_GATEWAY_KPI_URL"];
} else {
    URL = data["EC2_KPI_URL"];
}
console.log("#####################", URL);
export const updateLaneManagementKPIGraph = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_LANE_MANAGEMENT_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({ type: SET_LANE_MANAGEMENT_KPI_SUCCESS, payload: data["data"] });
                    }
                } else {
                    const { data } = response;
                    dispatch({ type: SET_LANE_MANAGEMENT_KPI_ERROR, payload: data.message });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_LANE_MANAGEMENT_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_LANE_MANAGEMENT_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_LANE_MANAGEMENT_KPI_ERROR, payload: error.message });
    }
};

export const resetLaneManagementKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_LANE_MANAGEMENT_KPI_RESET });
};

export const updateLongitudinalMotionKPIGraph = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_LONGITUDINAL_MOTION_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({
                            type: SET_LONGITUDINAL_MOTION_KPI_SUCCESS,
                            payload: data["data"],
                        });
                    }
                } else {
                    const { data } = response;
                    dispatch({ type: SET_LONGITUDINAL_MOTION_KPI_ERROR, payload: data.message });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_LONGITUDINAL_MOTION_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_LONGITUDINAL_MOTION_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_LONGITUDINAL_MOTION_KPI_ERROR, payload: error.message });
    }
};

export const resetLongitudinalMotionKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_LONGITUDINAL_MOTION_KPI_RESET });
};

export const updateSafeDrivingKPIGraph = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_SAFE_DRIVING_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({ type: SET_SAFE_DRIVING_KPI_SUCCESS, payload: data["data"] });
                    }
                } else {
                    const { data } = response;
                    dispatch({ type: SET_SAFE_DRIVING_KPI_ERROR, payload: data.message });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_SAFE_DRIVING_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_SAFE_DRIVING_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_SAFE_DRIVING_KPI_ERROR, payload: error.message });
    }
};

export const resetSafeDrivingKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_SAFE_DRIVING_KPI_RESET });
};

export const updateEgoVelocityKPIGraph = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_EGO_VELOCITY_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({ type: SET_EGO_VELOCITY_KPI_SUCCESS, payload: data["data"] });
                    }
                } else {
                    const { data } = response;
                    dispatch({ type: SET_EGO_VELOCITY_KPI_ERROR, payload: data.message });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_EGO_VELOCITY_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_EGO_VELOCITY_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_EGO_VELOCITY_KPI_ERROR, payload: error.message });
    }
};

export const resetEgoVelocityKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_EGO_VELOCITY_KPI_RESET });
};

export const updateL1LateralAccelerationKPIGraph = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_L1_LATERAL_ACCELERATION_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({
                            type: SET_L1_LATERAL_ACCELERATION_KPI_SUCCESS,
                            payload: data["data"],
                        });
                    }
                } else {
                    const { data } = response;
                    dispatch({
                        type: SET_L1_LATERAL_ACCELERATION_KPI_ERROR,
                        payload: data.message,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_L1_LATERAL_ACCELERATION_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_L1_LATERAL_ACCELERATION_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_L1_LATERAL_ACCELERATION_KPI_ERROR, payload: error.message });
    }
};

export const resetL1LateralAccelerationKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_L1_LATERAL_ACCELERATION_KPI_RESET });
};

export const updateL1LateralJerkKPIGraph = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_L1_LATERAL_JERK_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({ type: SET_L1_LATERAL_JERK_KPI_SUCCESS, payload: data["data"] });
                    }
                } else {
                    const { data } = response;
                    dispatch({ type: SET_L1_LATERAL_JERK_KPI_ERROR, payload: data.message });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_L1_LATERAL_JERK_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_L1_LATERAL_JERK_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_L1_LATERAL_JERK_KPI_ERROR, payload: error.message });
    }
};

export const resetL1LateralJerkKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_L1_LATERAL_JERK_KPI_RESET });
};

export const updateL1LongitudinalDecelerationKPIGraph = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_L1_LONGITUDINAL_DECELERATION_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({
                            type: SET_L1_LONGITUDINAL_DECELERATION_KPI_SUCCESS,
                            payload: data["data"],
                        });
                    }
                } else {
                    const { data } = response;
                    dispatch({
                        type: SET_L1_LONGITUDINAL_DECELERATION_KPI_ERROR,
                        payload: data.message,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_L1_LONGITUDINAL_DECELERATION_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_L1_LONGITUDINAL_DECELERATION_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_L1_LONGITUDINAL_DECELERATION_KPI_ERROR, payload: error.message });
    }
};

export const resetL1LongitudinalDecelerationKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_L1_LONGITUDINAL_DECELERATION_KPI_RESET });
};

export const updateL1LongitudinalAccelerationKPIGraph = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_L1_LONGITUDINAL_ACCELERATION_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({
                            type: SET_L1_LONGITUDINAL_ACCELERATION_KPI_SUCCESS,
                            payload: data["data"],
                        });
                    }
                } else {
                    const { data } = response;
                    dispatch({
                        type: SET_L1_LONGITUDINAL_ACCELERATION_KPI_ERROR,
                        payload: data.message,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_L1_LONGITUDINAL_ACCELERATION_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_L1_LONGITUDINAL_ACCELERATION_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_L1_LONGITUDINAL_ACCELERATION_KPI_ERROR, payload: error.message });
    }
};

export const resetL1LongitudinalAccelerationKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_L1_LONGITUDINAL_ACCELERATION_KPI_RESET });
};

export const updateL1LongitudinalJerkKPIGraph = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_L1_LONGITUDINAL_JERK_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({
                            type: SET_L1_LONGITUDINAL_JERK_KPI_SUCCESS,
                            payload: data["data"],
                        });
                    }
                } else {
                    const { data } = response;
                    dispatch({ type: SET_L1_LONGITUDINAL_JERK_KPI_ERROR, payload: data.message });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_L1_LONGITUDINAL_JERK_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_L1_LONGITUDINAL_JERK_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_L1_LONGITUDINAL_JERK_KPI_ERROR, payload: error.message });
    }
};

export const resetL1LongitudinalJerkKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_L1_LONGITUDINAL_JERK_KPI_RESET });
};

export const updateL1LongitudinalVelocityDropKPIGraph = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({
                            type: SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_SUCCESS,
                            payload: data["data"],
                        });
                    }
                } else {
                    const { data } = response;
                    dispatch({
                        type: SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_ERROR,
                        payload: data.message,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_ERROR, payload: error.message });
    }
};

export const resetL1LongitudinalVelocityDropKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_RESET });
};

export const updateL0CollisionCheckKPIGraph = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_L0_COLLISION_CHECK_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({
                            type: SET_L0_COLLISION_CHECK_KPI_SUCCESS,
                            payload: data["data"],
                        });
                    }
                } else {
                    const { data } = response;
                    dispatch({ type: SET_L0_COLLISION_CHECK_KPI_ERROR, payload: data.message });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_L0_COLLISION_CHECK_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_L0_COLLISION_CHECK_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_L0_COLLISION_CHECK_KPI_ERROR, payload: error.message });
    }
};

export const resetL0CollisionCheckKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_L0_COLLISION_CHECK_KPI_RESET });
};

export const updateL0LateralSafeDistanceKPIGraph = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_L0_LATERAL_SAFE_DISTANCE_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({
                            type: SET_L0_LATERAL_SAFE_DISTANCE_KPI_SUCCESS,
                            payload: data["data"],
                        });
                    }
                } else {
                    const { data } = response;
                    dispatch({
                        type: SET_L0_LATERAL_SAFE_DISTANCE_KPI_ERROR,
                        payload: data.message,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_L0_LATERAL_SAFE_DISTANCE_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_L0_LATERAL_SAFE_DISTANCE_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_L0_LATERAL_SAFE_DISTANCE_KPI_ERROR, payload: error.message });
    }
};

export const resetL0LateralSafeDistanceKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_L0_LATERAL_SAFE_DISTANCE_KPI_RESET });
};

export const updateL0LongitudinalSafeDistanceKPIGraph = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({
                            type: SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_SUCCESS,
                            payload: data["data"],
                        });
                    }
                } else {
                    const { data } = response;
                    dispatch({
                        type: SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_ERROR,
                        payload: data.message,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_ERROR, payload: error.message });
    }
};

export const resetL0LongitudinalSafeDistanceKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_RESET });
};

export const updateL0OffRoadCheckKPIGraph = (payload) => (dispatch) => {
    try {
        console.log(URL);
        dispatch({ type: SET_L0_OFF_ROAD_CHECK_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({
                            type: SET_L0_OFF_ROAD_CHECK_KPI_SUCCESS,
                            payload: data["data"],
                        });
                    }
                } else {
                    const { data } = response;
                    dispatch({ type: SET_L0_OFF_ROAD_CHECK_KPI_ERROR, payload: data.message });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_L0_OFF_ROAD_CHECK_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_L0_OFF_ROAD_CHECK_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_L0_OFF_ROAD_CHECK_KPI_ERROR, payload: error.message });
    }
};

export const resetL0OffRoadCheckKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_L0_OFF_ROAD_CHECK_KPI_RESET });
};

export const updateL0LaneMarkingCheckKPIGraph = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_L0_LANE_MARKING_CHECK_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({
                            type: SET_L0_LANE_MARKING_CHECK_KPI_SUCCESS,
                            payload: data["data"],
                        });
                    }
                } else {
                    const { data } = response;
                    dispatch({ type: SET_L0_LANE_MARKING_CHECK_KPI_ERROR, payload: data.message });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_L0_LANE_MARKING_CHECK_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_L0_LANE_MARKING_CHECK_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_L0_LANE_MARKING_CHECK_KPI_ERROR, payload: error.message });
    }
};

export const resetL0LaneMarkingCheckKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_L0_LANE_MARKING_CHECK_KPI_RESET });
};

export const updateL0IndicatorCheckingKPIGraph = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_L0_INDICATOR_CHECKING_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({
                            type: SET_L0_INDICATOR_CHECKING_KPI_SUCCESS,
                            payload: data["data"],
                        });
                    }
                } else {
                    const { data } = response;
                    dispatch({ type: SET_L0_INDICATOR_CHECKING_KPI_ERROR, payload: data.message });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_L0_INDICATOR_CHECKING_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_L0_INDICATOR_CHECKING_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_L0_INDICATOR_CHECKING_KPI_ERROR, payload: error.message });
    }
};

export const resetL0IndicatorCheckingKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_L0_INDICATOR_CHECKING_KPI_RESET });
};

export const updateL0SpeedLimitCheckKPIGraph = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_L0_SPEED_LIMIT_CHECK_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({
                            type: SET_L0_SPEED_LIMIT_CHECK_KPI_SUCCESS,
                            payload: data["data"],
                        });
                    }
                } else {
                    const { data } = response;
                    dispatch({ type: SET_L0_SPEED_LIMIT_CHECK_KPI_ERROR, payload: data.message });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_L0_SPEED_LIMIT_CHECK_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_L0_SPEED_LIMIT_CHECK_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_L0_SPEED_LIMIT_CHECK_KPI_ERROR, payload: error.message });
    }
};

export const resetL0SpeedLimitCheckKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_L0_SPEED_LIMIT_CHECK_KPI_RESET });
};

export const updateL0FalseIndicatorCheckKPIGraph = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_L0_FALSE_INDICATOR_CHECK_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({
                            type: SET_L0_FALSE_INDICATOR_CHECK_KPI_SUCCESS,
                            payload: data["data"],
                        });
                    }
                } else {
                    const { data } = response;
                    dispatch({
                        type: SET_L0_FALSE_INDICATOR_CHECK_KPI_ERROR,
                        payload: data.message,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_L0_FALSE_INDICATOR_CHECK_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_L0_FALSE_INDICATOR_CHECK_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_L0_FALSE_INDICATOR_CHECK_KPI_ERROR, payload: error.message });
    }
};

export const resetL0FalseIndicatorCheckKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_L0_FALSE_INDICATOR_CHECK_KPI_RESET });
};

export const updateRSSLongitudinalSafeCheckKPIGraph = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({
                            type: SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_SUCCESS,
                            payload: data["data"],
                        });
                    }
                } else {
                    const { data } = response;
                    dispatch({
                        type: SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_ERROR,
                        payload: data.message,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_ERROR, payload: error.message });
    }
};

export const resetRSSLongitudinalSafeCheckKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_RESET });
};

export const updateRSSLateralLeftSafeCheckKPIGraph = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({
                            type: SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_SUCCESS,
                            payload: data["data"],
                        });
                    }
                } else {
                    const { data } = response;
                    dispatch({
                        type: SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_ERROR,
                        payload: data.message,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_ERROR, payload: error.message });
    }
};

export const resetRSSLateralLeftSafeCheckKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_RESET });
};

export const updateRSSLateralRightSafeCheckKPIGraph = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_REQUEST });
        axios
            .post(URL, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    if (data["message"] === "success") {
                        dispatch({
                            type: SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_SUCCESS,
                            payload: data["data"],
                        });
                    }
                } else {
                    const { data } = response;
                    dispatch({
                        type: SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_ERROR,
                        payload: data.message,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                // if (
                //     error.hasOwnProperty("response") &&
                //     error.response.hasOwnProperty("data") &&
                //     error.response.data.hasOwnProperty("message")
                // ) {
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_ERROR, payload: error.message });
    }
};

export const resetRSSLateralRightSafeCheckKPIGraph = () => (dispatch) => {
    dispatch({ type: SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_RESET });
};
